import { Pipe, PipeTransform } from '@angular/core';
import { ProductService } from '../../common/_services/product.service';

@Pipe({
  name: 'dataproduct',
  pure: true,
  standalone: false,
})
export class DataproductPipe implements PipeTransform {
  constructor(private productService: ProductService) {}

  transform(value: any): any {
    if (!value || value === undefined) {
      return null;
    }

    const selected = this.productService.getProductById(+value);
    if (selected) {
      return selected;
    } else {
      return null;
    }
  }
}
